module.exports = __webpack_public_path__ + "img/SL7_4591-Bearbeitet.2e02d816.jpg";